import { INode, bindable, customAttribute, inject, watch } from 'aurelia';
import { t } from 'polotno/utils/l10n';
import tippy, { roundArrow } from 'tippy.js';

@inject(INode)
@customAttribute({ name: 'tippy' })
export class TippyAttribute {

  @bindable({ primary: true }) content: string;

  private tippyElement: any;
  private tippyInstance: any;

  constructor(private element: HTMLElement) {
    this.tippyElement = element;
  }

  attached() {
    this.handleContent();
  }

  @watch('content')
  handleContent() {
    if (this.content) {
      tippy(this.tippyElement, {
        content: this.content,
        theme: 'copymagico',
        arrow: roundArrow,
      });

      this.tippyElement?._tippy?.setContent(this.content)
    } else {
      this.tippyElement?._tippy?.destroy();
    }
  }
}